import React from "react";
import PropTypes from "prop-types";

import MainMultiple from "./MainMultiple";
import MainSimple from "./MainSimple";
import MainMultiplePanels from "./MainMultiplePanels";
import MainTwice from "./MainTwice";


const Dashboard = props => {

  const { body, info, chart, multiple, panel } = props
  //const classes = useStyles();
  const renderBody = () => {
    if (multiple) {
      if (panel === 3) {
        return <MainMultiplePanels
          info={info}
          chart={chart}
          body={body}

        />
      } else if (panel === 2) {
        return <MainTwice
          info={info}
          body={body}

        />
      } else {
        return <MainMultiple
          body={body}
          info={info}
          chart={chart}

        />
      }

    } else {
      return <MainSimple
        body={body}

      />
    }
  }

  return (
    <div>
      {
        renderBody()
      }

    </div>
  );
};

Dashboard.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.element.isRequired,
  chart: PropTypes.object,
  multiple: PropTypes.bool.isRequired,
};

export default Dashboard;
